import { NAME } from "./constants";

const select = key => state => state[NAME][key];

export const checkingAuth = select("checkingAuth");
export const isLoggedIn = select("isLoggedIn");
